import React from "react";
import { observer, inject } from "mobx-react";
import * as M from "@material-ui/core";
import ReactMarkdown from "react-markdown";
import * as Icon from "react-feather";

const StartDisco = ({ store }) => {
  const { $survey, $locale, $user, $router, $group, $config } = store;

  const survey =
    $survey.list.has("oHHAvZZm88LO6QqCeNzd") && $survey.list.get("oHHAvZZm88LO6QqCeNzd");

  return (
    <div className="lg:grid grid-cols-12">
      <aside className="col-span-4 p-8 flex flex-col justify-between">
        <div className="mb-3 ">
          <h2 className="color-primary leading-tight" onClick={e => $router.push("/")}>
            {$locale.t("start_title")}
          </h2>
          <div className="mt-4">
            <ReactMarkdown source={$locale.t("start_description")} />
          </div>
        </div>
        <div className="flex">
          {$user.sessionUser.id && !$user.sessionUser.isAnonymous && (
            <div>
              {$locale.t("user_logged_in")}{" "}
              {$user.sessionUser.email && <b>{$user.sessionUser.email}</b>}
              <button className="btn" />
            </div>
          )}
        </div>
      </aside>
      <section className="lg:col-span-8 ">
        <div className="bg-white border-radius-large">
          <div className="flex justify-center items-center flex-col h-full py-8 px-4">
            <h1 className="center mb-8">
              <Icon.CheckSquare size={36} color="#444" />
            </h1>
            <h1 className="center color-primary">
              {$locale.t(survey._key + "_surveyName") || survey.name}
            </h1>

            {$locale.t(survey._key + "introText") && (
              <ReactMarkdown
                className="mt-2 lg-col-10 p-8 bg-white border-radius-large"
                source={$locale.t(survey._key + "introText")}
              />
            )}

            <M.Button
              size="large"
              onClick={e => {
                $user.change("registerForCluster", "ouderbetrokkenheid");
                $user.change("enableRegister", true);
              }}
              icon={<Icon.Play />}
            >
              Registreer
            </M.Button>
          </div>
        </div>
        <div className="mt-8">{$locale.t("start_disclaimer")}</div>
      </section>
    </div>
  );
};

export default inject("store")(observer(StartDisco));
